import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Divider, Slide, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import BryxColors from "../../types/theme";
import BryxBox from "../BryxBox";
const BryxSideModal = styled(({ className, icon, title, children, open, anchor, SlideProps }) => {
    return (_jsx(Slide, { ...SlideProps, in: open, container: anchor.current, timeout: {
            appear: 250,
            enter: 250,
            exit: 150,
        }, enter: true, exit: true, mountOnEnter: true, unmountOnExit: true, children: _jsxs(Container, { className: className, children: [_jsxs(BryxBox, { isFlex: true, centerAlignItems: true, sx: { paddingLeft: "18px", paddingTop: "16px", paddingBottom: "28px" }, children: [icon, " ", _jsx(Typography, { sx: { marginLeft: "10px", fontWeight: "600", fontSize: "16px" }, children: title })] }), _jsx(Divider, { sx: { borderColor: "rgba(35, 8, 8, 0.2)" } }), _jsx(BryxBox, { sx: { padding: "12px 24px 0px 24px", height: "calc(100% - 68px)", overflowY: "scroll" }, children: children })] }) }));
})(({ theme }) => ({
    backgroundColor: `${theme.palette.mode === "light" ? "#FFFFFF" : BryxColors.darkModePopupBackground()}`,
    borderRadius: "4px",
    border: "1px solid rgba(35, 8, 8, 0.2)",
    "&.MuiContainer-root": {
        paddingLeft: "0px",
        paddingRight: "0px",
        height: "100vh",
        minWidth: "352px",
        width: "352px",
    },
}));
export default BryxSideModal;
